export default "__VITE_ASSET__C1D$fIu6__"